<template>
  <!-- Specific warning dialog -->
  <v-dialog v-model="isVisible" persistent max-width="600">
    <v-card class="simple-dialog">
      <v-card-title v-if="has_message_title" class="headline">{{ title }}</v-card-title>
      <v-card-text v-if="has_message_body">
        <p v-html="$sanitize(
                body, {
                allowedTags: ['b','br','i']
                })"></p>
      </v-card-text>
      <v-card-actions style="padding: 10px 24px;" class="justify-center">
        <v-btn v-if="display_negative_btn" :class="['btn','negative-btn', custom_negative_btn_classes]"
               @click="negative_btn_clicked">
          {{ get_negative_btn_txt }}
        </v-btn>
        <v-spacer v-if="display_negative_btn"></v-spacer>
        <v-btn :class="['btn','positive-btn', custom_positive_btn_classes]" @click="positive_btn_clicked()">
          {{ get_positive_btn_text }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SimplePopupComponent",
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '',
    },
    body: {
      type: String,
      default: '',
    },
    display_negative_btn: {
      type: Boolean,
      default: false
    },
    custom_negative_btn_text: {
      type: String,
      default: ''
    },
    custom_positive_btn_text: {
      type: String,
      default: ''
    },
    custom_negative_btn_classes: {
      type: String,
      default: 'btn-text',
    },
    custom_positive_btn_classes: {
      type: String,
      default: 'btn-text'
    },
  },
  methods: {
    positive_btn_clicked() {
      this.$emit('positive_btn_clicked');
    },
    negative_btn_clicked() {
      this.$emit('negative_btn_clicked');
    },
  },
  computed: {
    has_message_title() {
      if (this.title.length <= 0) {
        return false;
      }
      return true;
    },
    has_message_body() {
      if (this.body.length <= 0) {
        return false;
      }
      return true;
    },
    get_negative_btn_txt() {
      if (this.custom_negative_btn_text.length <= 0) {
        return this.$vuetify.lang.t('$vuetify.global.cancel');
      }
      return this.custom_negative_btn_text;
    },
    get_positive_btn_text() {
      if (this.custom_positive_btn_text.length <= 0) {
        return this.$vuetify.lang.t('$vuetify.global.ok');
      }
      return this.custom_positive_btn_text;
    }
  }
}
</script>

<style lang="scss">
.simple-dialog {
  .btn {
    &.btn-green {
      background-color: #4caf50 !important;
      border-color: #4caf50 !important;
      color: white !important;
    }

    &.btn-red {
      background-color: #ff5252 !important;
      border-color: #ff5252 !important;
      color: white !important;
    }

    &.btn-text {
      box-shadow: none !important;
      background-color: transparent !important;

      &.btn-green {
        color: darkred !important;
      }

      &.btn-red {
        color: darkgreen !important;
      }
    }
  }
}


</style>